import React from "react";
import { Container } from "react-bootstrap";

/************************************************ 
@Purpose : Used for Footer
@Parameter : {}
@Author : INIC
**************************************************/
function Footer() {
  return (
    // <footer className="mt-auto text-center p-3">
    //   <h6 className="font-weight-medium mb-0">
    //     IndiaNIC © {new Date().getFullYear()}
    //   </h6>
    // </footer>
    <footer className="mt-auto border-top py-3 bg-white">
    <Container>
      {/* Bootstrap 4: stacked and centred on small screens, one row from md up */}
      <div className='d-flex flex-column flex-md-row align-items-center justify-content-md-between text-center text-md-left'>
        <p className='mb-1 mb-md-0'>Candidate Portal</p>
        <p className='mb-0 ml-md-3'>IndiaNIC Infotech Limited © {new Date().getFullYear()}</p>
      </div>
    </Container>
  </footer>
  );
}
export default Footer;
